<script lang="ts">
/* -------------------------------------------------------------
 * SessionModal
 * -------------------------------------------------------------
 * Appears when the API returns 401 or refresh-token fails.
 * Emits **close** so the parent hides the modal.
 * ----------------------------------------------------------- */
import { createEventDispatcher } from 'svelte';
import { fade }                  from 'svelte/transition';

const dispatch = createEventDispatcher();

/** Message injected by sessionManager */
export let message: string =
  'Your session has expired. Please log in again to continue.';

function closeModal() {
  dispatch('close');          // parent flips `showSessionModal` → false
}

function handleReload() {
  closeModal();               // hide overlay first
  window.location.reload();   // hard refresh – guarantees clean state
}
</script>

<!-- ───────────── overlay ───────────── -->
<!-- clicks on the dark backdrop dismiss the modal -->
<div
  class="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999]"
  transition:fade={{ duration: 150 }}
  on:click={closeModal}
>
  <!-- ───────────── dialog ───────────── -->
  <!-- clicks inside the white card DO NOT close the modal -->
  <div
    class="w-[92vw] max-w-sm bg-white rounded-xl shadow-xl p-6 text-center space-y-6"
    on:click|stopPropagation
  >
    <header class="space-y-2">
      <h2 class="text-xl font-semibold text-gray-800">Session Expired</h2>
      <p class="text-sm text-gray-600">{message}</p>
    </header>

    <button
      class="w-full bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-white py-3 rounded-lg font-medium transition disabled:opacity-50"
      on:click={handleReload}
    >
      Reload Page
    </button>

    <button
      class="mx-auto block text-sm text-gray-500 hover:text-gray-700 underline"
      on:click={closeModal}
    >
      Log in without reloading
    </button>
  </div>
</div>
